export enum SignatureFormType {
  QUICK_SIGN = 'quick-sign',
}
